var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        fill: "#9BA2B6",
        height: "29",
        viewBox: "0 0 28 29",
        width: "28",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M27.912 12.89c-.044-.407-.503-.714-.9-.714a3.11 3.11 0 0 1-2.899-1.987 3.31 3.31 0 0 1 .783-3.585.827.827 0 0 0 .085-1.094 14.125 14.125 0 0 0-2.218-2.32.76.76 0 0 0-1.064.09c-.834.957-2.333 1.312-3.491.812-1.205-.525-1.966-1.79-1.891-3.148a.797.797 0 0 0-.688-.847c-1.046-.126-2.1-.13-3.15-.009a.799.799 0 0 0-.692.83c.045 1.344-.724 2.587-1.918 3.093-1.144.485-2.633.132-3.465-.817a.761.761 0 0 0-1.057-.092 14.168 14.168 0 0 0-2.265 2.32.827.827 0 0 0 .084 1.101 3.293 3.293 0 0 1 .783 3.618c-.484 1.192-1.679 1.96-3.047 1.96-.443-.015-.76.294-.808.712a15.051 15.051 0 0 0-.006 3.297c.044.41.516.714.918.714 1.22-.032 2.39.749 2.88 1.986a3.306 3.306 0 0 1-.782 3.586.826.826 0 0 0-.085 1.093c.65.858 1.397 1.638 2.214 2.32a.76.76 0 0 0 1.066-.087c.837-.96 2.336-1.315 3.49-.813 1.208.524 1.969 1.789 1.894 3.147a.797.797 0 0 0 .687.847 13.404 13.404 0 0 0 3.15.009.798.798 0 0 0 .693-.83c-.047-1.344.724-2.587 1.916-3.093 1.152-.487 2.634-.13 3.467.817a.763.763 0 0 0 1.056.092c.838-.68 1.6-1.46 2.265-2.32a.826.826 0 0 0-.083-1.102 3.292 3.292 0 0 1-.785-3.617c.476-1.176 1.627-1.965 2.864-1.965l.173.005c.402.033.771-.287.82-.712.124-1.09.125-2.199.006-3.297zM14 22.86c-4.458 0-8.071-3.743-8.071-8.36 0-4.617 3.613-8.36 8.07-8.36 4.459 0 8.072 3.743 8.072 8.36a8.542 8.542 0 0 1-1.141 4.286l-3.535-3.66a5.27 5.27 0 0 0 .391-2.001 5.184 5.184 0 0 0-1.45-3.624 4.831 4.831 0 0 0-4.802-1.32.571.571 0 0 0-.233.958s1.745 1.821 2.329 2.426c.061.063.061.214.052.268l-.005.04c-.059.665-.172 1.463-.266 1.77l-.037.037-.039.04c-.3.1-1.082.22-1.734.28v-.004l-.03.008a.366.366 0 0 1-.296-.117c-.607-.63-2.283-2.353-2.283-2.353a.56.56 0 0 0-.408-.188c-.24 0-.454.18-.522.437-.461 1.769.028 3.671 1.277 4.965a4.832 4.832 0 0 0 5.432 1.096l3.572 3.7A7.83 7.83 0 0 1 14 22.86z",
          "fill-rule": "nonzero",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }